module.exports = __webpack_public_path__ + "img/server.dbee5d15.svg";